// src/components/AreaDimensionsForm.js
import React, { useState } from "react";

const AreaDimensionsForm = ({ selectedTile, setArea }) => {
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setArea({ length, width });
  };

  if (!selectedTile) {
    return <p className="no-tile-message">Please select a tile first.</p>;
  }

  return (
    <form className="area-form" onSubmit={handleSubmit}>
      <h2 className="area-form-title">Enter Area Dimensions</h2>
      <div className="form-group">
        <label htmlFor="length" className="form-label">
          Length (m):
        </label>
        <input
          type="number"
          id="length"
          className="form-input"
          value={length}
          onChange={(e) => setLength(e.target.value)}
          required
          placeholder="Enter length in meters" // Add placeholder
        />
      </div>
      <div className="form-group">
        <label htmlFor="width" className="form-label">
          Width (m):
        </label>
        <input
          type="number"
          id="width"
          className="form-input"
          value={width}
          onChange={(e) => setWidth(e.target.value)}
          required
          placeholder="Enter width in meters" // Add placeholder
        />
      </div>
      <button type="submit" className="form-button">
        Calculate Tiles
      </button>
    </form>
  );
};

export default AreaDimensionsForm;
